/**
 * INPUT PARAMETERS
{
    onChangeFields: external function that handles changes in columns.
    selectItem: external function  // Replace standard behaviour select row and prevent any events like                                                 (footer.submit, edit). Incoming {ITEM} (selected object from table)
    add: external function,        // will appear 'ADD' button
    edit: external function,       // will appear 'EDIT' button if row selected
    download: external function,   // will appear icon "Download"
    upload: external function,     // will appear icon 'Upload'
    lastColumn: external function to show component it last column of each table row (takes all row data as a param and returns component)
    // groups: true,
    filter: external function,     // will appear 'search' input
    // save: this.save,
    // limitFields: ['type', 'lastEditDate'],
    handleSort: external function,
    total: external data on the general records number in response,
    t: external function for translating
    fields: {
        attach_id: {
            name: t('ID')
        },
        attach_type_id: {
            name: 'type',               // required! Name of column.
            classWidth: widths.min,     // required! number indicating the column width type (0..2)
            format: 'date',             // indicates if the original value should be changed to a different format ('string', 'number', 'date', 'translate')
            link: '/documents'          // link to be redirected after a click
            html: true,                 // flag indicating that the content should be output as html
            noSorted: true,             // flag for banning column sorting
            hidden: false,              // hiding flag
            permanent: true,            // flag for hiding columns
            value: data => data.id      // function that returns a value for a cell as a result of incoming data
            component: <p>{data}</p>    // component that will be inserted in the cell
        },
        ...
        tr: {
            dblClick: external function
        },
        footer: {                      // object, if footer exist render grid Footer Component
            submit: external function,
            cancel: external function
        },
        groups: {
            form: component with form,
            checkedItems: array of checked items,
            handleCheck: external function for sending checked items,
        }
    }
}
 **/

import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import DataManager from './DataManager';
import GridTable from './GridTable';
import Header from './Header';
import Footer from './Footer';
import FormsWrapper from './FormsWrapper';
import { getIdKey } from './helpers';
import GridFloatingButton from './GridFloatingButton';

class Grid extends React.Component {
    constructor(props) {
        super(props);
        const { params, data, selected, preSelected } = props;
        const initialState = {
            data,
            selected,
            isAppealFormOpened: true
        };
        if (!params.sort || !params.sort.onChange) {
            initialState.sort = {};
        }
        this.state = initialState;
    }
    
    componentWillReceiveProps(nextProps) {
        const { params, data, selected } = nextProps;
        // think about params sort issue and setState without condition
        if (selected) {
            this.setState({ data, selected });
        } else {
            this.setState({ data });
        }
    }

    toggleAppealForm = () => {
        this.setState(prevState => ({ isAppealFormOpened: !prevState.isAppealFormOpened }));
    };

    filter = (val, key) => {
        let add = false;

        for (let i in val) {
            if (!add && val.hasOwnProperty(i)) {
                add = add || (val[i] + '').includes(key);
            }
        }

        return add;
    };

    filterData = key => {
        const { data } = this.props;

        this.setState({ data: data.filter(val => this.filter(val, key)) });
    };

    // TODO functionality not used, refactor when needed
    filterFields = field => {
        console.error('function working not correct, need refactoring');
        // const { fields } = this.props.params;
        // let newFields = {};
        //
        // if (field !== 'all_fields') {
        //     for (let i in fields) {
        //         if (i === field) {
        //             newFields[i] = fields[i];
        //         }
        //     }
        // } else {
        //     newFields = this.props.params.fields;
        // }
        //
        // this.setState({ params: { ...this.state.params, fields: newFields } });
    };

    selectItem = item => {
        const { selected: prevSelected } = this.state;
        const { params } = this.props;
        const selected = { ...item };

        if (params.defaultId) {
            selected.id = item[getIdKey(params)];
        }

        if (selected.id || selected.id === 0) {
            if (params.selectItem) {
                params.selectItem(selected, prevSelected);
            } //  else {
                //this.setState({ selected });
            //}
            this.setState({ selected });
        }
    };

    handleSort = ({ field, order }) => {
        const { data, params: { sort } } = this.props;

        // if it's server side sorting
        if (sort && sort.onChange) return sort.onChange({ field, order });

        // if it's simple sorting
        return this.setState({
            data: data.sort((a, b) => {
                const direct = order === 'desc' ? 1 : -1;
                return a[field] > b[field] ? direct : -direct;
            }),
            sort: { field, order }
        });
    };

    handleCheck = e => {
        const { value, checked } = e.target;
        const { checkedItems, handleCheck } = this.props.params.groups;
        const items = checked
            ? [...checkedItems, value]
            : checkedItems.filter(item => item !== value);

        handleCheck({ checkedItems: items });

        if (!checkedItems.length && items.length) {
            this.setState({ isAppealFormOpened: true });
        }
    };

    render = () => {
        const { data, selected, isAppealFormOpened, sort: stateSort } = this.state;
        const { params, toggleRowVisibility, onGridRefresh, onGridExport, onGridFloatingButtonClick } = this.props;


        let isGridFloatingButtonShow = false;
        if (typeof onGridFloatingButtonClick === "function") {
            isGridFloatingButtonShow = true;
        }

        if (
            onGridFloatingButtonClick &&
            onGridFloatingButtonClick.asyncHandler &&
            typeof onGridFloatingButtonClick.asyncHandler === "function"
        ) {
            isGridFloatingButtonShow = true;
        }

        return (
            <div className="grid">
                <Header
                    params={params}
                    selected={selected}
                    filterData={this.filterData}
                    filterFields={this.filterFields}
                />
                <GridTable
                    params={params}
                    data={data}
                    selected={selected}
                    sort={{
                        ...stateSort,
                        ...params.sort,
                        handleSort: this.handleSort
                    }}
                    selectItem={this.selectItem}
                    toggleRowVisibility={toggleRowVisibility}
                    {...this.props.params.groups && {
                        groups: {
                            ...this.props.params.groups,
                            handleCheck: this.handleCheck
                        }
                    }}
                />
                <Footer params={params} selected={selected} onGridRefresh={onGridRefresh} onGridExport={onGridExport} />

                {this.props.params.groups && (
                    <FormsWrapper
                        {...this.props.params.groups}
                        filterOnlyCheckedItems={this.filterOnlyCheckedItems}
                        toggleAppealForm={this.toggleAppealForm}
                        isAppealFormOpened={isAppealFormOpened}
                    />
                )}
                {isGridFloatingButtonShow && <GridFloatingButton onGridFloatingButtonClick={onGridFloatingButtonClick} />}
            </div>
        );
    };
}

Grid.propTypes = {
    data: PropTypes.array,
    params: PropTypes.object.isRequired,
    // from DataManager
    toggleRowVisibility: PropTypes.func
};

export default DataManager(Grid);
